module.exports = __webpack_public_path__ + "img/Category.dc147f47.svg";